export type AdminNavigationItem = {
  title: string
  description: string
  href: string
  icon: string
  legacy?: boolean
}

export type AdminNavigationGroup = {
  id: string
  title: string
  icon: string
  items: AdminNavigationItem[]
}

export const adminNavigation: AdminNavigationGroup[] = [
  {
    id: 'learning',
    title: 'Обучение',
    icon: 'book',
    items: [
      {
        title: 'Модули',
        description: 'Учебные модули и уроки',
        href: '/admin/modules',
        icon: 'modules',
      },
      {
        title: 'Пути',
        description: 'Пути обучения',
        href: '/admin/paths',
        icon: 'paths',
        legacy: true,
      },
      {
        title: 'Roadmaps',
        description: 'Интерактивные дорожные карты',
        href: '/admin/roadmaps',
        icon: 'roadmap',
        legacy: true,
      },
      {
        title: 'Финансы лаборатории',
        description: 'Подписки PRO, начисления и выплаты',
        href: '/admin/finance',
        icon: 'server',
      },
      {
        title: 'Стенды',
        description: 'Практические лаборатории',
        href: '/admin/stands',
        icon: 'server',
      },
      {
        title: 'CTF',
        description: 'CTF и соревнования',
        href: '/admin/ctf',
        icon: 'flag',
        legacy: true,
      },
    ],
  },
  {
    id: 'content',
    title: 'Контент',
    icon: 'content',
    items: [
      {
        title: 'Статьи',
        description: 'Материалы Академии',
        href: '/admin/articles',
        icon: 'article',
        legacy: true,
      },
      {
        title: 'Статьи пользователей',
        description: 'Пользовательские публикации',
        href: '/admin/user-articles',
        icon: 'userArticle',
        legacy: true,
      },
      {
        title: 'Посты',
        description: 'Публикации и записи',
        href: '/admin/posts',
        icon: 'posts',
        legacy: true,
      },
      {
        title: 'Stories',
        description: 'Истории Академии',
        href: '/admin/stories',
        icon: 'stories',
        legacy: true,
      },
    ],
  },
  {
    id: 'users',
    title: 'Пользователи',
    icon: 'users',
    items: [
      {
        title: 'Пользователи',
        description: 'Аккаунты и управление пользователями',
        href: '/admin/users',
        icon: 'users',
        legacy: true,
      },
      {
        title: 'Сообщество',
        description: 'Управление сообществом',
        href: '/admin/community',
        icon: 'community',
        legacy: true,
      },
      {
        title: 'Отзывы',
        description: 'Модерация отзывов к модулям',
        href: '/admin/reviews',
        icon: 'reviews',
      },
      {
        title: 'Избранное',
        description: 'Пользовательское избранное',
        href: '/admin/favorite',
        icon: 'heart',
        legacy: true,
      },
    ],
  },
  {
    id: 'store',
    title: 'Магазин',
    icon: 'store',
    items: [
      {
        title: 'Товары',
        description: 'Физические и цифровые товары',
        href: '/admin/store/products',
        icon: 'package',
      },
      {
        title: 'Заказы',
        description: 'Заказы пользователей',
        href: '/admin/store/orders',
        icon: 'orders',
      },
      {
        title: 'Доставка',
        description: 'СДЭК и способы доставки',
        href: '/admin/store/delivery',
        icon: 'truck',
      },
      {
        title: 'Промокоды',
        description: 'Промокоды и скидки',
        href: '/admin/store/promocodes',
        icon: 'ticket',
      },
    ],
  },
  {
    id: 'monetization',
    title: 'Монетизация',
    icon: 'wallet',
    items: [
      {
        title: 'Корзины',
        description: 'Корзины пользователей',
        href: '/admin/cart',
        icon: 'cart',
        legacy: true,
      },
      {
        title: 'Наборы',
        description: 'Комплекты и bundles',
        href: '/admin/bundles',
        icon: 'bundle',
        legacy: true,
      },
      {
        title: 'Акции',
        description: 'Скидки и сезонные предложения',
        href: '/admin/season',
        icon: 'sale',
        legacy: true,
      },
    ],
  },
  {
    id: 'rewards',
    title: 'Награды',
    icon: 'award',
    items: [
      {
        title: 'Награды',
        description: 'Медали и достижения',
        href: '/admin/awards',
        icon: 'award',
      },
      {
        title: 'Daily Drop',
        description: 'Пул, веса и физические призы',
        href: '/admin/drops',
        icon: 'award',
      },
      {
        title: 'Рамки',
        description: 'Рамки профиля',
        href: '/admin/borders',
        icon: 'border',
        legacy: true,
      },
    ],
  },
  {
    id: 'activity',
    title: 'Активность',
    icon: 'activity',
    items: [
      {
        title: 'Мероприятия',
        description: 'События и активности',
        href: '/admin/events',
        icon: 'calendar',
        legacy: true,
      },
      {
        title: 'Статистика',
        description: 'Статистика Академии',
        href: '/admin/statistic',
        icon: 'chart',
        legacy: true,
      },
    ],
  },
  {
    id: 'system',
    title: 'Система',
    icon: 'settings',
    items: [
      {
        title: 'Обновления',
        description: 'Управление обновлениями',
        href: '/admin/update',
        icon: 'update',
        legacy: true,
      },
    ],
  },
]
